import * as React from 'react';
import {Link as RoutedLink} from 'react-router-dom';

import {ButtonCard} from '../../../card/button-card';
import {Illustration} from '../../../illustrations/illustration';
import {StackLegacy} from '../../../layout/stack/stack-legacy';
import {Link} from '../../../link/link';

import {PersonCardContent} from './person-card-content';

import styles from './addable-people.module.css';

export type AddablePerson = {
    id: string;
    name: string;
    location: string | null | undefined;
    jobTitle: string | null | undefined;
    position: string | null | undefined;
    hasPhone: boolean;
    hasEmail: boolean;
    hasLinkedinUrl: boolean;
};

type Props = {
    people: AddablePerson[];
    selectedPersonIds: string[];
    updateSelectedPersonIds: (personId: string) => void;
    onClickName?: (arg1: string) => void;
    onClose: () => void;
    adjustFiltersUrl?: string;
};

export function AddablePeople(props: Props) {
    return (
        <div>
            <div className={styles['list-header-container']}>
                <div className={styles['list-header']}>Select people to add to Nutshell</div>
                {props.adjustFiltersUrl && (
                    <Link
                        as={RoutedLink}
                        to={props.adjustFiltersUrl}
                        onClick={props.onClose}
                        variant='primary'
                        size='small'
                    >
                        Adjust filters
                    </Link>
                )}
            </div>
            {props.people.length ? (
                <StackLegacy spacing={8}>
                    {props.people.map((person) => {
                        const isSelected = props.selectedPersonIds.includes(person.id);

                        return (
                            <ButtonCard
                                key={person.id}
                                isFullWidth={true}
                                isSelected={isSelected}
                                onClick={() => {
                                    props.updateSelectedPersonIds(person.id);
                                }}
                            >
                                <PersonCardContent
                                    {...person}
                                    onClickName={props.onClickName}
                                    isSelected={isSelected}
                                />
                            </ButtonCard>
                        );
                    })}
                </StackLegacy>
            ) : (
                <div className={styles['empty-state']}>
                    <div className={styles.illustration}>
                        <Illustration src='magnifying-glass' width='100%' height='100%' />
                    </div>
                    <div>
                        No people were found. Your filters may be too specific, or there are no
                        trackable employees at this company.
                    </div>
                    <Link
                        as={RoutedLink}
                        to={props.adjustFiltersUrl}
                        onClick={props.onClose}
                        variant='button-primary'
                        size='big'
                    >
                        Adjust filters
                    </Link>
                </div>
            )}
        </div>
    );
}
